import * as yup from "yup";
import { phoneCheck } from "../../common/regex";

export const validationSchema = yup.object().shape({
  firstName: yup
    .string()
    .required("First name is required"),

  lastName: yup
    .string()
    .required("Last name is required"),

  phoneNumber: yup
    .string()
    .required("Phone number is required")
    .matches(/^[0-9]+$/, "Phone number must contain only digits")
    .matches(phoneCheck, "Please enter a valid 10-digit phone number starting with 6, 7, 8, or 9")
    .length(10, "Phone number must be exactly 10 digits"),

  Location: yup
    .string()
    .required("Location is required"),

  activeInactive: yup
    .boolean()
    .required("Status is required")
    .oneOf([true, false], "Status must be selected"),
});
